export default "__VITE_ASSET__Cy2QmhCc__"